import React, { useState, useEffect } from "react";
import Button from "./Button";
import ModalWrapper, { ModalContent } from "./ModalWrapper";

const Snackbar = ({
  label,
  actionLabel,
  onAction,
  onClose,
  showClose = false,
  fixed = false,
  position = "bottom", // "bottom" | "top"
  timeout = 0, // 0 means no timeout
  className,
  style,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(props.animate !== false);

  useEffect(() => {
    if (props.animate !== undefined) {
      setIsOpen(props.animate);
    }
  }, [props.animate]);

  useEffect(() => {
    if (timeout > 0 && isOpen) {
      const timer = setTimeout(() => {
        handleClose();
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [timeout, isOpen]);

  const handleClose = (e) => {
    setIsOpen(false);
  };

  const handleAfterAnimate = () => {
    if (onClose) {
      onClose();
    }
  };

  const classes = ["ta-snackbar", className].filter(Boolean).join(" ");

  const hasAction = actionLabel || onAction;
  const hasClose = showClose || onClose;

  return (
    <ModalWrapper
      animate={isOpen}
      noScrim={true}
      transparent={true} // Snackbars shouldn't block underlying interaction
      onAfterAnimate={handleAfterAnimate} // Use our wrapper to trigger onClose only when ModalWrapper finishes
      zIndex={props.zIndex} // Optional manual override, otherwise ModalWrapper calculates via useLevel()
    >
      <div
        className={classes}
        style={style}
        data-fixed={fixed || undefined}
        data-from={fixed ? position : undefined}
        {...props}
      >
        <ModalContent>
          <>
            <div className="ta-snackbar_label">{label}</div>
            {hasAction || hasClose ? (
              <div className="ta-snackbar_action">
                {hasAction ? (
                  <Button variant="text" onClick={onAction}>
                    {actionLabel}
                  </Button>
                ) : null}
                {hasClose ? (
                  <Button icon symbol="close" onClick={handleClose} />
                ) : null}
              </div>
            ) : null}
          </>
        </ModalContent>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(Snackbar);
